import React from 'react'

function PrimaryButton({label,onClick,classes}) {
  return (
    <div>
      <button className={`px-5 py-3 text-base rounded-md border primary_btn transition-all duration-500 ${classes}`} onClick={onClick}>{label}</button>
    </div>
  )
}

export default PrimaryButton
